export interface IDeviceViewData {
  id: string;
  ipAddress: string;
  port?: number;
  pollingFrequency: number;
  username: string;
  directory: string;
  path: string;
  isAutoLine: boolean;
  isConnected: boolean;
  connectionType: string;
  connectionTypeId: string;
}

export default class DeviceViewData implements IDeviceViewData {
  id: string;
  ipAddress: string;
  port?: number;
  pollingFrequency: number;
  username: string;
  directory: string;
  path: string;
  isAutoLine: boolean;
  isConnected: boolean;
  connectionType: string;
  connectionTypeId: string;

  constructor(
    id: string,
    ipAddress: string,
    port: number,
    pollingFrequency: number,
    username: string,
    directory: string,
    path: string,
    isAutoLine: boolean,
    isConnected: boolean,
    connectionType: string,
    connectionTypeId: string
  ) {
    this.id = id;
    this.ipAddress = ipAddress;
    this.port = port;
    this.pollingFrequency = pollingFrequency;
    this.username = username;
    this.directory = directory;
    this.path = path;
    this.isAutoLine = isAutoLine;
    this.isConnected = isConnected;
    this.connectionType = connectionType;
    this.connectionTypeId = connectionTypeId;
  }
}

const defaultDeviceViewData = new DeviceViewData(
  "",
  "",
  0,
  0,
  "",
  "",
  "",
  false,
  false,
  "",
  ""
);
export { defaultDeviceViewData };
